import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-patient-mgt',
  templateUrl: './patient-mgt.component.html',
  styleUrls: ['./patient-mgt.component.css']
})
export class PatientMgtComponent implements OnInit {

  searchForm: FormGroup | any;
  patientList: any = [];
  itemPerPage: any = 10;
  currentPage: any = 1;
  total: any;
  csvArr: any = [];
  patientId: any;
  patientStatus: any;
  programList: any = [];
  maxDate: Date | any;

  constructor(private service: MainService, private router: Router) { }

  ngOnInit() {
    this.searchForm = new FormGroup({
      'search': new FormControl(''),
      'disease': new FormControl(''),
      'status': new FormControl(''),
      'fromDate': new FormControl(''),
      'toDate': new FormControl('')
    });
    this.service.BlockFuture();
    this.PatientListApi();
    this.viewProgramList();
    const currentYear = new Date()
    this.maxDate = new Date(currentYear);
  }
  deleteUserModal(id: any) {
    this.patientId = id;
    $('#deleteUser').modal('show')
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  // delete patient api integration 
  deletePatientApi() {
    const data = {
      "userId": this.patientId,
      "status": "DELETE"
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.actionPerform_patient, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        $('#deleteUser').modal('hide')
        this.service.successToast(res.responseMessage)
        this.service.hideSpinner();
        this.PatientListApi();
      } else {
        this.service.hideSpinner();
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  Reset() {
    this.searchForm.reset();
    this.PatientListApi();
  }

  pagination(page: number) {
    this.currentPage = page;
    this.PatientListApi();

  }

  // Patient list api integration 
  PatientListApi() {
    if (this.searchForm.value.fromDate && this.searchForm.value.toDate) {
      if (this.searchForm.value.fromDate > this.searchForm.value.toDate) {
        this.service.errorToast('Start time should be less than end time');
        return

      }
    }

    let date = new Date(this.searchForm.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.searchForm.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }

    const data = {
      search: this.searchForm.value.search,
      "fromDate": this.searchForm.value.fromDate,
      "toDate": this.searchForm.value.toDate,
    }

    if (this.searchForm.value.fromDate) {
      data['fromDate'] = year + '-' + month + '-' + dt
    }
    if (this.searchForm.value.toDate) {
      data['toDate'] = year1 + '-' + month1 + '-' + dt1
    }


    this.service.showSpinner()
    this.service.postApi(ApiUrls.patientList + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.patientList = res.result;
        this.total = res.paginationData.total;

        this.patientList.forEach((ele: any, index: number) => {
          let date = new Date(ele.createdAt);
          let year = date.getFullYear();
          let month: any = date.getMonth() + 1;
          let dt: any = date.getDate();

          if (dt < 10) {
            dt = '0' + dt;
          }
          if (month < 10) {
            month = '0' + month;
          }
          let finalDate = dt + '/' + month + '/' + year;
          this.csvArr.push({
            "Sr. No.": index + 1,
            "Patient name": ele.firstName + ' ' + ele.lastName,
            "Email address": ele.email,
            "Date of joining": finalDate,
            "Therapist Name": ele.myTherapist.length != 0 ? ele.myTherapist[0].firstName + ' ' + ele.myTherapist[0].lastName : "NA",
            "Program": ele.programSubscription ? ele.programSubscription.title : "NA",
          })
        });
        this.service.hideSpinner();
      }

    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  openActiveBlock(status: any, id: any) {
    this.patientStatus = status;
    this.patientId = id;
    $('#actBlockStatus').modal('show')
  }

  updateActiveBlock() {
    $('#actBlockStatus').modal('hide')
    this.patientStatus == 'ACTIVE' ? this.patientStatus = 'BLOCK' : this.patientStatus = 'ACTIVE';
    const data = {
      userId: this.patientId,
      status: this.patientStatus
    }
    this.service.postApi(ApiUrls.actionPerform_patient, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage)
        this.PatientListApi();
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })

  }


  viewProgram(id: any, therapistId: any) {
    const data = {
      "patientId": id,
      "therapistId": therapistId
    }
    this.router.navigate(['view-patient'], { queryParams: { value: JSON.stringify(data) } })
  }

  // edit Program routing 
  editProgram(id: any, assignStatus: any) {
    const data = {
      "id": id,
      "assignStatus": assignStatus
    };

    this.router.navigate(['edit-patient/'], { queryParams: { value: JSON.stringify(data) } })
  }

  // export csv format

  exportCsv() {
    var options = {
      showLabels: true,
      headers: ["Sr. No.", "Patient name", "Email address", "Date of joining"
        , "Therapist Name", "Program"]
    };
    var exportFile = new ngxCsv(this.csvArr, 'Patients Report', options);
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
